import {Divider, Row} from 'antd';
import React from "react";
import StyledDrawer from "./LicenceDetailsDrawer.style";
import moment from 'moment';
import licenceActionButtons from "../../licenceActionButtons";
import {LicenceStatusText} from "../../../../constants/LicenceStatus";
import LicenceElements from "../LicenceElements";
import {DATE_FORMAT} from "../../../../constants/dateFormat";

const DescriptionItem = ({title, content}) => (
    <div className="site-description-item-profile-wrapper">
        <p className="site-description-item-profile-p-label">{title}:</p>&nbsp;{content}
    </div>
);


const columnsToDisplay = [
    {
        key: "company",
        title: "Company",
        render: item => item.companyHasSoftwareProductWithCompanyAndSoftwareProductResponse.companyResponse.companyName
    },
    {
        key: "softwareProduct",
        title: "Software Product",
        render: item => item.companyHasSoftwareProductWithCompanyAndSoftwareProductResponse.softwareProductResponse.code
    },
    {
        key: "code",
        title: "Code",
        render: item => item.companyHasSoftwareProductWithCompanyAndSoftwareProductResponse.code
    },
    {key: "licenceNumber", title: "Licence Number"},
    {key: "currentProductVersion", title: "Current Product Version"},
    {key: "status", title: "Status", render: ({status}) => LicenceStatusText[status]},
    {key: "statusDescription", title: "Status Description"},
    {
        key: "issueDate",
        title: "Issue Date",
        render: ({issueDate}) => issueDate && moment(issueDate).format(DATE_FORMAT)
    },
    {
        key: "onlineValidationLastSync",
        title: "Online Validation Last Sync",
        render: ({onlineValidationLastSync}) => onlineValidationLastSync && moment(onlineValidationLastSync).format(DATE_FORMAT)
    },
];

const LicenceDetailsDrawer = ({
                                  darkMode, primaryColor, licenceToShowDetailsFor, licenceDetailsVisible, toggleLicenceDetails,
                                  onRevokeClick,
                                  onDeleteClick,
                                  onLicenceSend,
                                  onSendPassword,
                                  onSendOfflineValidationTokenViaEmail,
                                  onSendOfflineValidationTokenViaSms,
                                  showLicenceInfo,
                                  onLicenceDownload,
                                  onPublicKeyDownload
                              }) => {

    return licenceToShowDetailsFor ? (
        <StyledDrawer
            width={320}
            darkMode={darkMode}
            className={darkMode && 'dark-mode'}
            placement="right"
            onClose={() => toggleLicenceDetails(false)}
            visible={licenceDetailsVisible}
        >
            <p className="site-description-item-profile-p" style={{marginBottom: 24}}>
                Licence Info
            </p>
            {
                columnsToDisplay.map(({key, title, render}) => (<Row key={key}>
                    <DescriptionItem title={title} content={
                        render ? render(licenceToShowDetailsFor) :
                            licenceToShowDetailsFor[key]
                    }/>
                </Row>))
            }

            {
                licenceToShowDetailsFor.content && (<>
                    <Divider/>
                    <p className="site-description-item-profile-p">Licence Elements</p>
                    <LicenceElements record={licenceToShowDetailsFor}/>
                </>)
            }

            <>
                <Divider/>
                <p className="site-description-item-profile-p">Actions</p>

                {licenceToShowDetailsFor &&
                licenceActionButtons({
                    record: licenceToShowDetailsFor,
                    onRevokeClick,
                    onDeleteClick,
                    onLicenceSend,
                    onSendPassword,
                    onSendOfflineValidationTokenViaEmail,
                    onSendOfflineValidationTokenViaSms,
                    showLicenceInfo,
                    onLicenceDownload,
                    onPublicKeyDownload,
                    licenceDetailsVisible,
                    toggleLicenceDetails,
                    twoToneColor: primaryColor
                }, true)
                }

            </>

        </StyledDrawer>
    ) : null;
};

export default LicenceDetailsDrawer;